export const isIterableArray = <T>(array: T[]) =>
  Array.isArray(array) && !!array.length
